import { useState } from 'react';

interface MilestoneItem {
  id: string;
  date: string;
  title: string;
  description: string | null;
  sessionId: string | null;
}

interface Props {
  milestone: MilestoneItem;
  linkedSessionDate?: string;
  onEdit: () => void;
  onDelete: () => void;
}

const DATE_FMT = new Intl.DateTimeFormat('de-DE', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
});

export function TimelineMilestoneCard({
  milestone,
  linkedSessionDate,
  onEdit,
  onDelete,
}: Props) {
  const [menuOpen, setMenuOpen] = useState(false);
  const dateLabel = DATE_FMT.format(new Date(milestone.date));

  return (
    <div className="relative pl-6">
      <span className="absolute left-[1px] top-2 inline-block h-3 w-3 rounded-full border-2 border-amber-500 bg-amber-100" />
      <div className="relative rounded-md border border-amber-500/40 bg-amber-50/40 px-3 py-2.5 dark:bg-amber-500/5">
        <div className="text-[10px] font-medium uppercase tracking-wider text-amber-700 dark:text-amber-400">
          Meilenstein · {dateLabel}
        </div>
        <div className="mt-0.5 text-sm font-semibold">{milestone.title}</div>
        {milestone.description && (
          <p className="mt-1 text-xs leading-relaxed text-foreground/80">
            {milestone.description}
          </p>
        )}
        {milestone.sessionId && linkedSessionDate && (
          <p className="mt-1 text-[10px] italic text-muted-foreground">
            ↳ verknüpft mit Session vom{' '}
            {DATE_FMT.format(new Date(linkedSessionDate))}
          </p>
        )}

        <div className="absolute right-2 top-2">
          <button
            type="button"
            className="rounded p-1 text-muted-foreground hover:bg-muted"
            aria-label="Optionen"
            onClick={() => setMenuOpen((v) => !v)}
          >
            ⋮
          </button>
          {menuOpen && (
            <div className="absolute right-0 mt-1 w-32 rounded border border-border bg-card py-1 shadow-md">
              <button
                type="button"
                className="block w-full px-3 py-1 text-left text-xs hover:bg-muted"
                onClick={() => {
                  setMenuOpen(false);
                  onEdit();
                }}
              >
                Bearbeiten
              </button>
              <button
                type="button"
                className="block w-full px-3 py-1 text-left text-xs text-destructive hover:bg-muted"
                onClick={() => {
                  setMenuOpen(false);
                  onDelete();
                }}
              >
                Löschen
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
